import type { MultiSelectOption } from '@/components/ui/multi-select';

/**
 * The MCP tool surface an install can allow, grouped by module. This mirrors the
 * tools registered in the dev13 MCP server (integrations/mcp/dev13_mcp/tools/*).
 * The MCP guard enforces the allowlist at call time — this list only powers the
 * install picker, so keep it in sync when tools are added/removed there.
 */
const TOOLS_BY_MODULE: Record<string, string[]> = {
  Knowledge: ['kb_search', 'list_knowledge_bases'],
  Agents: ['list_agents', 'get_agent', 'list_results', 'get_result', 'save_result'],
  CRM: [
    'list_companies',
    'get_company',
    'create_company',
    'list_contacts',
    'create_contact',
    'list_leads',
    'create_lead',
    'list_deals',
    'get_deal',
    'create_deal',
    'update_deal',
    'list_proposals',
    'list_activities',
  ],
  HRM: [
    'list_departments',
    'list_employees',
    'get_employee',
    'create_employee',
    'update_employee',
    'list_time_off',
    'list_skills',
  ],
  Projects: [
    'list_projects',
    'get_project',
    'create_project',
    'list_states',
    'list_cycles',
    'list_work_items',
    'get_work_item',
    'create_work_item',
    'update_work_item',
    'list_modules',
    'list_work_item_types',
    'list_relations',
    'create_relation',
    'delete_relation',
    'list_worklogs',
    'log_time',
    'list_attachments',
    'list_work_item_comments',
    'add_work_item_comment',
  ],
  Pages: [
    'list_wiki_collections',
    'list_wiki_pages',
    'get_wiki_page',
    'create_wiki_page',
    'update_wiki_page',
    'list_project_pages',
    'get_project_page',
    'create_project_page',
    'update_project_page',
    'wiki_page_subtree',
    'project_page_subtree',
  ],
  Meta: ['whoami'],
};

/** Flat, grouped option list for the Allowed-tools MultiSelect. */
export const TOOL_OPTIONS: MultiSelectOption[] = Object.entries(TOOLS_BY_MODULE).flatMap(
  ([group, tools]) => tools.map((value) => ({ value, group })),
);
